import './styles/global-app.scss'; // Core global styles first

import React from 'react';
import { createRoot } from 'react-dom/client';
import AppContainer from './containers/AppContainer';
import store from './store';
import * as Sentry from '@sentry/browser';
import { getSentryEnv, logSentryException } from './services/util';
import './i18n/i18n';
import { gaInitialize, gaPageView } from './components/Reports/blocks/ReportAnalytics';
// import * as axe from '@axe-core/react';

window.onerror = function(e){
  if(e.includes("ResizeObserver loop limit exceeded")){
   return true;
  }

  if(e.includes("unityAbort")){
    console.log("Reloading due to Unity Abort");
    logSentryException(e, "Reloading due to Unity Abort");
    location.reload();
  }
}

// Show the git commmit hash
console.log(BRANCH,VERSION,COMMITHASH);

// Initialize Google Analytics
gaInitialize();
gaPageView("/", "Login Page");


// Dynamically log accessibility issues to console for analysis
const urlParams = new URLSearchParams(window.location.search);
// if (process.env.NODE_ENV !== 'production' && urlParams.get("logA11y")) {
//   const axeConfig = {
//     disableDeduplicate: true,
//   };

//   axe(React, ReactDOM, 1000, axeConfig);
// }

// Render app
createRoot(document.getElementById('root'))
 .render(<AppContainer store={store} />);

// Initialize Sentry
 Sentry.init({
    dsn: "https://47a3a1d7d1c69c8686690dfdcfff9cd7@o246901.ingest.us.sentry.io/4509294692466688",
    beforeSend: filterEvents,
    release: process.env.COMMITHASH,
    environment: getSentryEnv(),
    sendDefaultPii: true,
  },
  );

  //TODO: move to another file.

  let alreadyAllowedEvent = false;
  function filterEvents(event,hint){
    if(event && event.exception && event.exception.values){
      let exception = event.exception.values[0];
      if(exception.type == "TypeError" && exception.value == "Unable to get property 'x' of undefined or null reference"
        && exception.stacktrace && exception.stacktrace.frames && exception.stacktrace.frames[exception.stacktrace.frames.length-1]
        && (exception.stacktrace.frames[exception.stacktrace.frames.length-1].function == "handlerFunc")){
          if(alreadyAllowedEvent){
            console.log("Eating error",event);
            return null;
          }else{
            alreadyAllowedEvent = true;
          }
      }
    }
    return event;
  }
